<template>
  <div>
    <div id="footer" class="clearfix">
      <div id="footer-widget-area" class="clearfix">
        <div class="col_one_fourth">
          <div id="text-2" class="widget widget_text clearfix">
            <div class="textwidget">
              <div id="text-2" class="widget widget_text clearfix">
                <div class="textwidget">
                  <p>
                    <img src="../assets/imgs/footer-logo.png" alt="Appsy Logo" title="Appsy Logo"/>
                    <br>
                    <br>
                    A ferramenta APPSY é operada pela ORB9, empresa especializada em soluções corporativas de mobilidade.
                  </p>
                                
                  <div class="wcontact-info-icon">
                    <img src="../assets/imgs/icons/signpost.png" alt="Localização" title="Localização" />
                    Brasília-DF, Brasil
                  </div>
                                
                  <div class="wcontact-info-icon">
                    <img src="../assets/imgs/icons/mail.png" alt="E-mail de suporte" title="E-mail de suporte" />
                    suporte@orb9.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col_one_fourth">
          <div id="testimonials_widget-2" class="widget testimonials-widget clearfix">
            <h4 class="widget-title">Depoimentos</h4>        
            <vueper-slides
              ref="testimonials"
              fixed-height="300px"
              :fade="true"
              :transitionSpeed="800"
              :arrows="false"
              :bullets="false">
              <vueper-slide>
                <div slot="slideContent">
                <div class="wtestimonial-content">A linha de tempo contém todos registros relativos a um paciente, com acesso a qualquer momento. É uma ótima forma para acompanhar mais de perto a evolução do quadro.</div>
                <div class="wtestimonial-author">Dr. Geder Grohs<span></span></div>
                </div>
              </vueper-slide>
              <vueper-slide>
                <div slot="slideContent">
                <div class="wtestimonial-content">O Appsy tem sido perfeito para estruturar meu trabalho de preceptor. Toda a equipe o utiliza e abandonamos a reunião com papeizinhos.</div>
                <div class="wtestimonial-author">Dr. Marco André<span></span></div>
                </div>
              </vueper-slide>
              <vueper-slide>
                <div slot="slideContent">
                  <div class="wtestimonial-content">O APPSY é um serviço que combina tecnologia de fácil utilização e metodologias desruptivas de trabalho, para multiplicar a capacidade de execução do psiquiatra e aumentar adesão dos pacientes.</div>
                  <div class="wtestimonial-author">Ulisses Campos<span></span></div>
                  </div>
              </vueper-slide>
            </vueper-slides>
            <div class="portfolio-widget-prev" style="display: block;"
              @click="$refs.testimonials.prev()"></div>
            <div class="portfolio-widget-next" style="display: block;"
              @click="$refs.testimonials.next()"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="copyrights" class="clearfix">
      <div id="foo-left">© 2023 Appsy. Todos os direitos reservados</div>
      <div id="foo-right"></div>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

export default {
  components: {
    VueperSlides,
    VueperSlide,
  },
};
</script>

<style lang="stylus">
  .vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom)
    position: static !important
    transform: none !important
    text-align: right !important

  .vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper:after
  .vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper:before
    content: none !important

  a
    &:link
      text-decoration: none !important
    &:hover
      text-decoration: none !important
    &:active
      text-decoration: none !important
</style>
